<template>
  <div class="duty-auth" @mousedown="moveStop">
    <span v-if="isEnterDutyTpl" @click="onCLickTemplate" style="color:var(--g-color-primary); line-height: 18px;cursor: pointer;">
      <i class="iconfont icon-xitongguanli" style="margin-right: 4px;"></i>岗位模板
    </span>

    <el-dialog
      class="duty-template kye-dialog__modal-in-tab"
      v-drag
      :visible.sync="showTemplate"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="escape"
      title="岗位模板"
      width="720px"
      :canResize="false"
      :showFullScreenButton="false"
      @close="dutyTemplateClose"
      @open="onOpen">
      <div class="main-wrap" v-loading="templateLoading">
        <div class="main-wrap_left">
          <div class="main-wrap_left-top">
            <el-autocomplete
              ref="templateFilter"
              v-model="templateKey"
              clearable
              placeholder="搜索模板名"
              class="tpl-popper"
              popper-class="kye-popper-auto"
              value-key="name"
              :trigger-on-focus="false"
              :fetch-suggestions="filterTemplate"
              @select="selectTemplate">
              <i slot="prefix" class="layout layout-search"></i>
            </el-autocomplete>
            <el-tooltip content="新增" placement="top">
              <el-button type="text" icon="layout layout-plus" @click="addTemplate"></el-button>
            </el-tooltip>
          </div>
          <el-scrollbar>
            <ul class="tpl-list">
              <li class="tpl" v-for="(item, index) in templateList" :key="index">
                <div
                  :class="`name ${templateIndex === index ? 'is-active' : ''}`"
                  :title="item.name.length > 13 ? item.name : ''"
                  @click="loadTemplate(index)">{{item.name}}
                </div>
                <div v-show="templateIndex === index && templateFlag !== 'copy'" style="display: flex;align-items: center;">
                  <el-tooltip content="复制" placement="top">
                    <i class="iconfont icon-gongdanxitong" @click="copyTemplate(index)"></i>
                  </el-tooltip>
                  <el-tooltip content="删除" placement="top">
                    <i class="el-icon-delete red" @click="removeTemplate(index)"></i>
                  </el-tooltip>
                </div>
              </li>
              <li v-if="templateList.length === 0" class="center">暂无数据</li>
            </ul>
          </el-scrollbar>
        </div>
        <div class="main-wrap_right">
          <el-form ref="form" :model="form" label-width="64px" :rules="rules">
            <h3 class="kye-block-title">对象设置<span slot="label" class="kye-label-click" @click="onClickUser" style="font-size: 12px;font-weight: 400;margin-left: 10px;">人员预览</span></h3>
            <div class="main-wrap_right-conent">
              <kye-row>
                <kye-col :span="12">
                  <kye-form-item label="模板名称" prop="templateName" :rules="{ required: true, message: '请输入标题', trigger: 'blur' }">
                    <kye-input type="input" maxlength="16" v-model="form.templateName"></kye-input>
                  </kye-form-item>
                </kye-col>
              </kye-row>
              <kye-row>
                <kye-col :span="12">
                  <kye-form-item prop="dept" label="组织">
                    <el-input
                      readonly
                      :value="showDeptLabel"
                      @click.native="openDeptTree"
                      @focus="deptFocus = true"
                      @blur="deptFocus = false"
                      @mouseenter.native="deptFocus = true"
                      @mouseleave.native="deptFocus = false">
                      <i
                        slot="suffix"
                        v-show="deptFocus && showDeptLabel"
                        class="el-input__icon el-icon-circle-close el-input__clear"
                        @click.stop="clearDept">
                      </i>
                    </el-input>
                  </kye-form-item>
                </kye-col>
              </kye-row>
              <kye-row>
                <kye-col :span="24">
                  <kye-form-item label="岗位" prop="dutyList">
                    <div class="kye-form-item__block">
                      <!-- <el-select
                        v-model="duty"
                        style="width:110px;"
                        clearable
                        remote
                        filterable
                        placeholder=""
                        :loading="dutyLoading"
                        :remote-method="fetchDuty"
                        @change="selectDuty">
                        <el-option
                          v-for="item in duties"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select> -->
                      <div class="collapse-select" v-clickoutside="handleClose">
                        <el-input
                          ref="dutyInput"
                          clearable
                          v-model="duty"
                          @input="dutyInput"
                          @clear="dutyClear"
                        >
                        </el-input>
                        <transition name="el-zoom-in-top">
                            <div
                              v-show="showDutyList"
                              v-loading="dutyLoading"
                              class="collapse-select__content">
                              <el-scrollbar>
                                <el-tree
                                  ref="tree"
                                  accordion
                                  show-checkbox
                                  :default-expanded-keys="['all']"
                                  :props="{ children: 'children', label: 'label' }"
                                  :data="duties"
                                  node-key="value"
                                >
                                </el-tree>
                              </el-scrollbar>
                              <div class="collapse-select-btn-box">
                                <kye-button type="primary" class="collapse-select-btn" @click="dutyConfirm">确定</kye-button>
                                <kye-button class="collapse-select-btn" @click="dutyCancel">取消</kye-button>
                              </div>
                            </div>
                        </transition>
                      </div>
                      <kye-tag
                        v-for="(v, index) of form.dutyList"
                        :key="v.value"
                        closable
                        style="margin: 0 5px;"
                        @close="delDuty(index)"
                      >{{ v.label }}</kye-tag>
                    </div>
                  </kye-form-item>
                </kye-col>
              </kye-row>
            </div>
            <h3 class="kye-block-title">字段设置</h3>
            <div class="main-wrap_right-conent main-wrap_field">
              <kye-row>
                <kye-col :span="24">
                  <el-tabs v-model="active">
                    <el-tab-pane
                      v-for="(item, i) in dutyTables"
                      v-if="item.searchCode"
                      :key="i"
                      :label="item.option.label || '字段设置'"
                      :name="'tab'+i">
                      <el-input
                        style="margin-top:4px;"
                        :ref="'input' + i"
                        placeholder="输入列名后可定位到指定项"
                        @keypress.enter.native="hanldeNextClick(i)"
                        @input="val => filterChange(val, i)">
                        <el-button slot="append" @click="hanldeNextClick(i)">下一个</el-button>
                      </el-input>
                      <div class="header-title">
                        <el-checkbox
                          v-model="checkedMap[i].value"
                          :indeterminate="checkedMap[i].indeterminate"
                          @change="e => handleCheckAll(e, item.$columns, i, item)">全选
                        </el-checkbox>
                        <span>字段名(上下拖动排序)</span>
                        <span class="header-title_sort">输入序号移动</span>
                      </div>
                      <div ref="draggableWrapper" class="tabs-content" style="display:flex;">
                        <draggable
                          ref="draggable"
                          tag="ul"
                          style="flex:1;"
                          :list="item.$columns"
                          v-bind="dragOptions">
                          <li
                            v-for="(col, index) in item.$columns"
                            :key="col.key"
                            v-if="!col.undraggable"
                            style="position: relative;"
                            class="item"
                            :class="{'is-active': checkedMap[i].activeKey === col.key, undraggable: col.disabled}">
                            <i v-show="item.option.draggableChild && col.children && col.children.length > 0"
                              :class="!col.expand ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"
                              style="font-size: 14px;position: absolute; top: 4px; left: 0px;color: #c0c4cc;"
                              @click.stop="clickExpand(col)">
                            </i>
                            <el-checkbox
                              v-model="col.$show"
                              :disabled="col.disabled"
                              :indeterminate="item.option.draggableChild && col.indeterminate"
                              @change="handleCheck(item.$columns, i, item, col)">
                              {{getColumnLabel(item.$columns, col)}}
                            </el-checkbox>
                            <draggable
                              v-show="!col.expand"
                              :key="'dragKey' + index"
                              ref="draggable"
                              tag="div"
                              style="flex:1;"
                              :list="col.children"
                              v-bind="dragOptions">
                              <div
                                v-for="col2 in col.children"
                                :key="col2.propertyName"
                                v-if="item.option.draggableChild && !col2.undraggable"
                                :class="{'is-active': checkedMap[i].activeKey === col2.key, undraggable: col2.disabled || col.disabled}"
                                class="item">
                                <el-checkbox
                                  v-model="col2.$show"
                                  :disabled="col2.disabled || col.disabled"
                                  @change="handleCheckChild(col, col2)">{{col2.label}}
                                </el-checkbox>
                              </div>
                            </draggable>
                            <input
                              type="number"
                              :min="1"
                              :max="item.$columns.length"
                              maxlength="3"
                              class="sort-num"
                              :oninput="`if(+value>${item.$columns.length})value=${item.$columns.length}`"
                              onkeypress="return (/[\d|\-|+|.]/.test(String.fromCharCode(event.keyCode || event.which)))"
                              @blur="e => onNumberBlur(e, i, index, col)" />
                          </li>
                        </draggable>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </kye-col>
              </kye-row>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" hotkey="ctrl+s" @click="save">保存(S)</el-button>
        <el-button @click="dutyTemplateClose">取消</el-button>
      </div>
    </el-dialog>

    <dept-dialog
      ref="deptDialog"
      @change="changeDept"
      :preloadDeptTree="false"
    >
    </dept-dialog>

    <el-dialog
      class="user-info kye-dialog__modal-in-tab"
      :visible.sync="showUserlist"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="escape"
      @close="userInfoClose"
      title="人员预览"
      width="600px">
      <div v-loading="userLoading">
        <div class="user-info_form">
          <el-form :inline="true" :model="userForm">
            <el-form-item label="姓名/工号">
              <kye-search-tips
                v-model="userForm.employeeName"
                placeholder="请输入姓名/工号"
                style="width:150px;"
                url="data.employee.listByName"
                value-key="chineseName"
                :format-data="searchData"
                @clear="clearEmployeeName"
                @select="chooseEmployeeName"
                :clearable="true">
              </kye-search-tips>
            </el-form-item>
            <el-button
              type="primary"
              icon="layout layout-search1"
              hotkey="ctrl+q"
              @click="onUserSubmit">查询(Q)
            </el-button>
          </el-form>
        </div>
        <el-table
          ref="table"
          border
          :data="userList"
          :max-height="tableHeight">
        <el-table-column type="index" width="45"></el-table-column>
        <el-table-column
          prop="employeeNumber"
          label="工号"
          width="60"
          sortable
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="chineseName"
          label="姓名"
          width="100"
          sortable
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="position"
          label="岗位"
          width="120"
          sortable
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="departmentName"
          label="组织"
          sortable
          show-overflow-tooltip>
        </el-table-column>
      </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Draggable from 'vuedraggable'
  import localforage from 'localforage'
  import DeptDialog from './dept-dialog'
  import { cloneDeep, intersection } from 'lodash'
  import Clickoutside from 'element-ui/lib/utils/clickoutside'

  const EMPTY_LIST = []

  export default {
    components: {
      Draggable,
      DeptDialog
    },
    props: {
      // tables: Array,
      option: Object
    },
    directives: { Clickoutside },
    data () {
      // const dutyValidate = (rule, value, callback) => {
      //   if (this.form.dutyList.length === 0) {
      //     callback(new Error('请输入岗位'))
      //   } else {
      //     callback()
      //   }
      // }
      return {
        // isEnterDutyTpl: false,
        escape: true,
        showTemplate: false,
        templateFlag: 'add',
        templateKey: '',
        templateIndex: '-1',
        templateList: [],
        dragOptions: {
          draggable: '.item',
          handle: '.item',
          animation: 150,
          filter: '.undraggable',
          ghostClass: 'kye-ghost'
        },
        checkedMap: {
          '0': { value: false, indeterminate: false, activeKey: '', dragKey: 'dragKey0', activeIndex: -1 },
          '1': { value: false, indeterminate: false, activeKey: '', dragKey: 'dragKey1', activeIndex: -1 }
        },
        dutyTables: [],
        active: 'tab0',
        // table: {
        //   $columns: [],
        //   columns: []
        // },
        deptFocus: false,
        dept: {
          propertyName: 'dept',
          queryValue2: null,
          _queryValue: [{ label: '跨越集团', value: ['-11'] }],
          containLeaf: false,
          auth: true
        },
        duty: '',
        dutyLoading: false,
        duties: [],
        showDutyList: false,
        showUserlist: false,
        userList: [],
        userLoading: false,
        userForm: {
          employeeName: '',
          employeeNumber: ''
        },
        tableHeight: Math.floor(window.innerHeight * 0.7 - 112),
        templateLoading: false,
        form: this.createForm(),
        rules: {
          // dutyList: [{ required: true, trigger: 'change', validator: dutyValidate }]
        }
      }
    },
    // watch: {
    //   tables: {
    //     deep: true,
    //     handler () {
    //       this.init(this.tables)
    //     }
    //   }
    // },
    computed: {
      showDeptLabel () {
        let arr = this.dept._queryValue
        if (arr && arr.length) {
          return arr.map(v => v.label).join()
        }
        return ''
      },
      isEnterDutyTpl () {
        return this.$store.state.permission.menus.includes('BToRFUnXV7li')
      }
    },
    // created () {
    //   this.showDutyTplEnter()
    // },
    methods: {
      /**
       * 阻止冒泡，防止拖动个性设置
       */
      moveStop (e) {
        e.stopPropagation()
      },
      /**
       * 初始化
       */
      init (tables) {
        this.dutyTables = cloneDeep(tables)
        // this.getTAllemplate()
        // this.showDutyTplEnter()
        this.getColumns()
      },
      /**
       * 打开岗位模板
       */
      onOpen () {
        this.$bus.$emit('preload-dept-tree')
        this.getTAllemplate()
        // this.init(this.tables)
      },
      /**
       * 关闭岗位模板
       */
      dutyTemplateClose () {
        this.active = 'tab0'
        this.templateFlag = 'add'
        this.templateIndex = '-1'
        this.templateList = []
        this.showTemplate = false
        this.duties = []
        this.$refs.form && this.$refs.form.clearValidate()
        this.form = this.createForm()
      },
      // /**
      //  * 获取白名单权限
      //  */
      // async showDutyTplEnter () {
      //   let isEnter = false
      //   try {
      //     let employeeId = window.__ERPUSER__.id
      //     let res = await this.$http('auth.business.columWhite.searchByEmployId', { vo: { employeeId } })
      //     isEnter = res
      //   } catch (e) {
      //     isEnter = false
      //   }
      //   // 有场景会出现自定义列是本地数据，不是从【通用查询】获取的配置数据
      //   const hasCode = this.dutyTables.some(item => item.searchCode)
      //   this.isEnterDutyTpl = hasCode && !!isEnter
      // },
      /**
       * 获取 columns
       */
      getColumns (tables = []) {
        this.dutyTables.forEach((v, i) => {
          this.$set(this.checkedMap, i, {
            value: false,
            indeterminate: false,
            activeKey: '',
            dragKey: 'dragKey' + i,
            activeIndex: -1
          })
          // v.$columns = v.$columns.map(v => ({...v, expand: true}))
          this.handleCheck(v.$columns, i, v)
          if (v.option.draggableChild) {
            v.$columns.forEach(col => this.setColType(col))
          }
        })
      },
      /**
       * 设置 columns
       */
      setColumns (tab, userArr, tableIndex) {
        let originArr = tab.columns.map(v => ({...v}))
        if (originArr && originArr.length) {
          let flag = !!userArr
          let userKeys = []
          let userChildKeys = {}
          // 如果没有交集，则取公共模板
          if (flag) {
            userKeys = userArr.map(item => {
              if (typeof item === 'string') return item
              if (item.child && item.child.length) userChildKeys[item.key] = item.child
              return item.key || ''
            })
            let keys = originArr.map(v => v.key)
            keys = intersection(keys, userKeys)
            flag = keys && keys.length > 0
          }
          let length = flag ? userArr.length : 0
          // let prefix = `${tab.url.method}.data.rows.`
          originArr.forEach(v => {
            // 用户自定义的字段排序在前面
            if (flag) {
              let index = userKeys.indexOf(v.key) + 1
              v.index = index || ++length
              v.show = index > 0 || !!v.fixed
            }
            if (v.show && v.children && userChildKeys[v.key]) {
              let childLength = flag ? userChildKeys[v.key].length : 0
              v.children.forEach(child => {
                let childIndex = userChildKeys[v.key].indexOf(child.key) + 1
                child.index = childIndex || ++childLength
                child.show = childIndex > 0
                child.$show = childIndex > 0
              })
              v.children.sort((a, b) => a.index - b.index)
            }
            // v.indeterminate = !(userChildKeys[v.key] && userChildKeys[v.key].length === v.children.length)
            if (v.children && !v.show) {
              v.children.forEach(child => {
                child.show = false
                child.$show = false
              })
              // v.indeterminate = false
            }
            v.indeterminate = (userChildKeys[v.key] && userChildKeys[v.key].length !== v.children.length)
            v.$show = !!v.show
            v.show = !!v.show
            // v.expand = true
          })
          if (flag) {
            originArr.sort((a, b) => a.index - b.index)
          }
          tab.columns = originArr
          tab.$columns = [...originArr]
          this.checkedMap[tableIndex].value = originArr.every(v => !!v.$show)
          this.checkedMap[tableIndex].indeterminate = originArr.some(v => !v.$show)
        }
      },
      /**
       * 创建表单
       */
      createForm () {
        return {
          id: '',
          templateName: '',
          deptId: '-11',
          departmentIdRoute: '/-11/',
          departmentRoute: '/跨越集团/',
          dutyList: []
        }
      },
      /**
       * 显示岗位模板
       */
      onCLickTemplate () {
        this.showTemplate = true
      },
      /**
       * 保存
       */
      save () {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            let tasks = []
            for (let i = 0; i < this.dutyTables.length; i++) {
              let tab = this.dutyTables[i]
              let code = tab.searchCode
              if (!code) {
                continue
              }
              let keys = tab.$columns.filter(v => (v.$show || v.indeterminate)).map(v => {
                if (tab.option && !tab.option.draggableChild) {
                  return v.key
                } else {
                  if (!v.$show && v.indeterminate) v.$show = v.indeterminate
                }
                let child = []
                if (v.children) {
                  v.children.forEach(item => {
                    if (item.$show) child.push(item.key)
                  })
                }
                return { key: v.key, child }
              })
              if (keys.length === 0) {
                this.$message.warning('请至少保留一列')
                return
              }
              tasks.push({ genericId: this.option[code], fieldContent: JSON.stringify(keys) })
            }

            let params = {
              templateName: this.form.templateName,
              departmentIdRoute: this.form.departmentIdRoute,
              departmentRoute: this.form.departmentRoute,
              dutyId: this.form.dutyList.map(v => v.value).join(','),
              dutyName: this.form.dutyList.map(v => v.label).join(','),
              menuId: this.option.menuId,
              templateColumnList: tasks
            }
            console.log(params, this.dutyTables, this.option)
            let url = 'system.genericSearchFieldTemplate.save'
            let msg = '保存成功！'
            if (this.form.id) {
              params.id = this.form.id
              url = 'system.genericSearchFieldTemplate.update'
              msg = '更新成功！'
            }
            try {
              this.templateLoading = true
              let res = await this.$http(url, params)
              this.$message.success(msg)
              let obj = { name: params.templateName, id: res }
              params.id && this.templateList.splice(this.templateIndex, 1, obj)
              if (this.templateFlag === 'add') {
                let len = this.templateList.push(obj)
                this.templateIndex = len - 1
              } else if (this.templateFlag === 'copy') {
                this.templateList.splice(this.templateIndex, 1, obj)
              }
              console.log('save', params, this.templateList, this.templateIndex)
              this.form.id = res
              this.templateFlag = 'info'
              // 清除本地通用查询模板的缓存
              localforage.createInstance({ name: 'api' }).clear()
              this.templateLoading = false
            } catch (error) {
              this.templateLoading = false
            }
          } else {
            this.$rule.error(this, this.$refs.form)
          }
        })
      },
      /**
       * 新增模板
       */
      addTemplate () {
        let init = () => {
          this.form = this.createForm()
          this.dept._queryValue = [{ label: '跨越集团', value: ['-11'] }]
          this.getColumns()
          this.templateIndex = '-1'
          this.templateFlag = 'add'
        }
        if (this.templateFlag === 'copy') {
          this.$confirm('是否保存该模板？', '提示')
            .then(_ => {
              this.form.id = null
              this.save()
            })
            .catch(_ => {
              this.templateList.splice(this.templateIndex, 1)
              init()
            })
        } else {
          init()
        }
      },
      /**
       * 复制模板
       */
      copyTemplate () {
        let index = this.templateIndex
        let name = this.templateList[index].name + '-副本'
        this.templateList.splice(index + 1, 0, { name, id: null })
        this.templateIndex = index + 1
        this.templateFlag = 'copy'
        this.form.templateName = name
        this.form.id = null
      },
      /**
       * 获取模板列表
       */
      async getTAllemplate () {
        let genericIds = []
        for (let i = 0; i < this.dutyTables.length; i++) {
          let tab = this.dutyTables[i]
          let code = tab.searchCode
          if (!code) {
            continue
          }
          genericIds.push(this.option[code])
        }
        try {
          this.templateLoading = true
          let res = await this.$http('system.genericSearchFieldTemplate.getTemplateNames', { genericIds, menuId: this.option.menuId })
          this.templateList = res.map(v => ({ name: v.templateName, id: v.id }))
          this.templateIndex = '-1'
          this.templateLoading = false
        } catch (error) {
          this.templateLoading = false
        }
      },
      /**
       * 获取当前模板
       */
      async getTemplate (index) {
        let res = await this.$http('system.genericSearchFieldTemplate.queryInfo', { id: this.templateList[index].id })
        this.form.id = res.id
        this.form.templateName = res.templateName
        this.form.departmentIdRoute = res.departmentIdRoute
        this.form.departmentRoute = res.departmentRoute
        let departmentRoute = res.departmentRoute.split('/')
        let departmentIdRoute = res.departmentIdRoute.split('/')
        let depId = departmentIdRoute[departmentIdRoute.length - 2]
        this.dept._queryValue = [{ label: departmentRoute[departmentRoute.length - 2], value: depId }]
        this.form.deptId = depId

        if (res.dutyId && res.dutyName) {
          let dutyId = res.dutyId.split(',')
          let dutyName = res.dutyName.split(',')
          let dutyList = []
          dutyId.forEach((v, index) => {
            if (v) {
              dutyList.push({
                label: dutyName[index],
                value: v
              })
            }
          })
          this.form.dutyList = dutyList
        } else {
          this.form.dutyList = []
        }
        // 设置列
        let list = res.templateColumnList || []
        for (let i = 0, len = this.dutyTables.length; i < len; i++) {
          let tab = this.dutyTables[i]
          let code = tab.searchCode
          if (!code) {
            continue
          }
          let genericId = this.option[code]
          for (let j = 0, tLen = list.length; j < tLen; j++) {
            let tabList = list[j]
            let id = tabList.genericId
            if (genericId === id) {
              let userArr = JSON.parse(tabList.fieldContent || '[]')
              this.setColumns(tab, userArr, i)
              break
            }
          }
        }
      },
      /**
       * 删除当前模板
       */
      async removeTemplate (index) {
        await this.$confirm('是否删除该模板？', '提示')
        await this.$http('system.genericSearchFieldTemplate.delete', { id: this.templateList[index].id })
        this.templateList.splice(index, 1)
        this.addTemplate()
        this.$message.success('删除成功！')
      },
      /**
       * 加载当前模板
       */
      async loadTemplate (index) {
        this.$refs.form && this.$refs.form.clearValidate()
        if (this.templateFlag === 'copy') {
          this.$confirm('是否保存该模板？', '提示')
            .then(_ => {
              this.form.id = null
              this.save()
            })
            .catch(_ => {
              this.templateFlag = 'info'
              this.templateList.splice(this.templateIndex, 1)
              this.templateIndex = index
              this.getTemplate(index)
            })
        } else {
          this.templateFlag = 'info'
          this.templateIndex = index
          this.getTemplate(index)
        }
      },
      /**
       * 选择模板
       */
      selectTemplate (val) {
        if (val) {
          let index = this.templateList.findIndex(v => val.name === v.name)
          this.loadTemplate(index)
          this.templateKey = ''
        }
      },
      /**
       * 模板筛选
       */
      filterTemplate (val, cb) {
        if (!this.templateList.length || !val || val.length < 2) {
          cb(EMPTY_LIST)
          return
        }
        let arr = this.templateList.filter(v => v.name && v.name.includes(val))
        cb(arr)
        // 自动选择第一行
        this.$nextTick(_ => {
          arr.length && this.$refs['templateFilter'].highlight && this.$refs['templateFilter'].highlight(0)
        })
      },
      /**
       * 打开组织树
       */
      openDeptTree () {
        this.$refs.deptDialog.open(this.dept)
      },
      /**
       * 组织树变化
       */
      changeDept (e) {
        let deptId = e.value[0]
        this.form.deptId = deptId
        this.form.departmentIdRoute = e.deptMap[deptId].departmentIdRoute || `/${e.deptMap[deptId].ids.replace(/,/g, '/')}/`
        this.form.departmentRoute = `/${e.deptMap[deptId].departmentRoute}/`
        console.log('changeDept', e, this.dept, this.form)
      },
      /**
       * 清除组织
       */
      clearDept () {
        this.dept._queryValue = null
      },
      /**
       * 获取岗位
       */
      fetchDuty (val) {
        if (!val || val.length < 2) return
        this.dutyLoading = true
        this.$http('hr.duty.getDutyByConditionNew', { name: val })
          .then(res => {
            this.dutyLoading = false
            if (res && res.length) {
              this.duties = res.map(v => ({ label: v.name, value: v.id }))
            }
          })
          .catch(_ => {
            this.dutyLoading = false
          })
      },
      /**
       * 选择岗位
       */
      selectDuty (val) {
        if (!val) return
        let isHas = this.form.dutyList.some(v => v.value === val)
        if (!isHas) {
          let obj = this.duties.find(v => v.value === val)
          this.duty = ''
          this.form.dutyList.push({ ...obj })
          return
        }
        return this.$message.warning('请勿重复添加！')
      },
      /**
       * 删除岗位
       */
      delDuty (index) {
        this.form.dutyList.splice(index, 1)
      },
      /**
       * 显示人员预览
       */
      onClickUser () {
        this.showUserlist = true
        this.getUserList()
      },
      /**
       * 人员预览详情关闭
       */
      userInfoClose () {
        this.userForm.employeeName = ''
        this.userForm.employeeNumber = ''
        this.userList = []
        this.showUserlist = false
      },
      /**
       * 获取人员预览
       */
      async getUserList (form = {}) {
        let params = {
          ...form,
          subsidiaryDepartment: 'Y',
          departmentId: this.form.deptId,
          dutyIds: this.form.dutyList.map(v => v.value)
        }
        this.userLoading = true
        let res = await this.$http('hr.remoteEmployee.list', params)
        this.userList = res.map(v => {
          return {
            id: v.id,
            employeeNumber: v.employeeNumber,
            chineseName: v.name,
            position: v.duty,
            departmentName: v.departmentInfo.departmentRoute
          }
        })
        this.userLoading = false
      },
      /**
       * 人员搜索
       */
      searchData (val) {
        if (!val || val.length < 2) return
        let data = null
        if (/^[0-9]+$/.test(val)) {
          data = { employeeNumber: val, status: '10' }
        } else {
          data = { chineseName: val, status: '10' }
        }
        return data
      },
      /**
       * 清楚搜索员工
       */
      clearEmployeeName () {
        this.userForm.employeeName = ''
        this.userForm.employeeNumber = ''
      },
      /**
       * 选择搜索员工
       */
      chooseEmployeeName (val) {
        this.userForm.employeeName = val ? val.chineseName : ''
        this.userForm.employeeNumber = val ? val.employeeNumber : ''
      },
      /**
       * 人员预览搜索
       */
      onUserSubmit () {
        let form = {
          name: this.userForm.employeeName,
          employeeNumbers: this.userForm.employeeNumber ? [this.userForm.employeeNumber] : []
        }
        this.getUserList(form)
      },
      /**
       * 2021-08-06
       * @param val 搜索字段
       * @param i 当前页签索引
       * @param mode 操作方式
       */
      filterChange (val, i, mode = 'input') {
        val = val.trim()
        if (val) {
          let tab = this.dutyTables[i]
          let isDraggableChild = tab.option && tab.option.draggableChild
          let num = -1

          let flatArr = []
          // 扁平化处理
          tab.$columns.forEach((v, index) => {
            flatArr.push({ ...v })
            // 如果是显示二级的
            if (isDraggableChild && v.children && v.children.length) {
              v.children.forEach(child => {
                flatArr.push({
                  ...child,
                  _parentkey: v.key,
                  _parentIndex: index
                })
              })
            }
          })

          // 过滤不展示字段
          flatArr = flatArr.filter(item => !item.undraggable)

          // 如果匹配在末位，需重置匹配
          // 实时搜索，需重置匹配
          let last = flatArr.map(v => ({ ...v })).reverse().find(v => v.label.includes(val))
          if ((last && last.key === this.checkedMap[i].activeKey) || mode === 'input') {
            this.checkedMap[i].activeIndex = -1
            this.checkedMap[i].activeKey = ''
          }

          // 模糊匹配
          num = flatArr.findIndex((v, index) => v.label.includes(val) && this.checkedMap[i].activeIndex < index)

          if (num > -1) {
            let obj = flatArr[num]
            this.checkedMap[i].activeKey = obj.key
            this.checkedMap[i].activeIndex = num
            // 是否是二级头，二级头折叠情况，需默认展示
            if (obj._parentkey) {
              this.$set(this.dutyTables[i].$columns[obj._parentIndex], 'expand', false)
            }
            let col = this.dutyTables[i].$columns[0]
            col.$show = !col.$show
            col.$show = !col.$show
            this.$refs.draggableWrapper[i].scrollTo({ top: num * 25, behavior: 'smooth' })
          }
        } else {
          this.checkedMap[i].activeKey = ''
          this.checkedMap[i].activeIndex = -1
          let col = this.dutyTables[i].$columns[0]
          col.$show = !col.$show
          col.$show = !col.$show
        }
      },
      /**
       * 全选变化
       */
      handleCheckAll (val, arr, key, tab) {
        arr.forEach(v => {
          if (!v.undraggable && !v.disabled) {
            v.$show = !!val
            if (tab && tab.option && tab.option.draggableChild && v.children) {
              v.children.forEach(child => {
                if (!child.undraggable && !child.disabled) {
                  child.$show = !!val
                }
              })
              v.indeterminate = false
            }
          }
        })
        this.checkedMap[key].value = val
        this.checkedMap[key].indeterminate = false
      },
      /**
       * 单选变化
       */
      handleCheck (arr, key, tab, col) {
        if (!arr || !arr.length) return
        const flag = arr[0].$show
        this.checkedMap[key].value = arr.every(v => v.$show)
        this.checkedMap[key].indeterminate = arr.some(v => v.$show !== flag)
        if (tab && tab.option && tab.option.draggableChild) {
          if (col && col.children) {
            col.children.forEach(child => {
              if (!child.undraggable && !child.disabled) {
                child.$show = !!col.$show
              }
            })
            col.indeterminate = false
          }
        }
      },
      /**
       * 子节点选择
       */
      handleCheckChild (col) {
        this.setColType(col)
      },
      /**
       * 设置列状态
       * @param col
       */
      setColType (col) {
        if (col.children && col.children.length) {
          const curChild = col.children.filter(child => !child.undraggable)
          let showChild = curChild.filter(child => child.$show)
          col.$show = col.show = curChild.length === showChild.length
          col.indeterminate = !col.$show && !!showChild.length
          // this.$set(col, 'indeterminate', !col.$show && !!showChild.length)
        }
      },
      /**
       * 获取列名
       */
      getColumnLabel (columns, col) {
        // let start = index + 1 - this.checkedMap[tableIndex].length
        // return `${index + 1}. ${label}`
        const label = col.realLabel || col.label
        const findIndex = columns.filter(item => !item.undraggable).findIndex(item => item.key === col.key)
        return `${findIndex + 1}. ${label}`
      },
      /**
       * 展开隐藏
       */
      clickExpand (col) {
        // col.expand = !col.expand
        this.$set(col, 'expand', !col.expand)
      },
      /**
       * 数字排序
       */
      onNumberBlur (e, tableIndex, oldIndex, col) {
        let newIndex = +e.target.value
        if (newIndex && newIndex > 0) {
          e.target.value = ''
          let columns = this.dutyTables[tableIndex].$columns
          columns.splice(newIndex - 1, 0, columns.splice(oldIndex, 1)[0])
          this.checkedMap[tableIndex].activeKey = col.key
          // 改变key属性值，强制渲染draggable
          // 否则会触发draggable的onDragUpdate方法，此时this.context未赋值
          this.checkedMap[tableIndex].dragKey = Math.random().toString()
        }
      },
      /**
       * 岗位实时搜索
       */
      dutyInput (val) {
        val = val.trim()
        if (!val || val.length < 2) return
        clearTimeout(this.timer)
        this.timer = null
        this.dutyLoading = true
        this.showDutyList = true
        this.timer = setTimeout(_ => {
          this.$http('hr.duty.getDutyByConditionNew', { name: val })
            .then(res => {
              this.dutyLoading = false
              if (res && res.length) {
                this.duties = [{
                  label: '全部',
                  value: 'all',
                  children: res.map(v => ({ label: v.name, value: v.id }))
                }]
              } else {
                this.duties = []
              }
            })
            .catch(_ => {
              this.showDutyList = false
              this.dutyLoading = false
            })
          }, 300)
      },
      /**
       * 清除
       */
      dutyClear () {
        this.initDutyParams()
      },
      /**
       * 关闭岗位列表浮窗
       */
      handleClose () {
        this.initDutyParams()
      },
      /**
       * 岗位确认
       */
      dutyConfirm () {
        let res = this.$refs.tree.getCheckedNodes(true)
        if (res.length === 0) {
          return this.$message.warning('请选择岗位')
        }
        res.forEach(v => {
          let isHas = this.form.dutyList.some(item => item.value === v.value)
          if (!isHas) {
            this.form.dutyList.push({ ...v })
          }
        })
        this.initDutyParams()
      },
      /**
       * 岗位取消
       */
      dutyCancel () {
        this.initDutyParams()
      },
      initDutyParams () {
        this.duty = ''
        this.showDutyList = false
        clearTimeout(this.timer)
        this.timer = null
      },
      /**
       * 2021-08-08
       * 支持下一个 enter
       */
      hanldeNextClick (index) {
        let currentValue = this.$refs[`input${index}`] && this.$refs[`input${index}`][0].currentValue
        if (currentValue) {
          this.filterChange(this.$refs[`input${index}`][0].currentValue, index, 'nextBtn')
        }
      }
    }
  }
</script>

<style lang="scss">
  .duty-auth {
    .duty-template, .user-info {
      pointer-events: none;
      cursor: default;
    }
    .duty-template .el-dialog__body {
      padding: 0;
      // overflow-y: hidden;
    }
    .el-checkbox {
      width: auto;
    }
    .main-wrap {
      display: flex;
      // &_field {
      //   height: 300px;
      //   overflow: auto;
      // }
      &_left {
        &-top {
          display: flex;
          padding: 6px;
        }
        width: 172px;
        border-right: 1px solid #dcdbe2;
        .tpl-popper {
          .el-input__inner {
            padding-left: 24px !important;
            padding-right: 6px !important;
            border-radius: 14px;
            color: #333333;
            border-color: #dbdae6;
            background-color: #ffffff;
          }
          .el-input__prefix {
            top: 5px;
            padding-left: 4px;
            font-size: 14px;
            color: #b3b1b1;
          }
        }
        .tpl-list {
          overflow: auto;
          .tpl {
            height: 24px;
            display: flex;
            align-items: center;
            padding: 0 6px;
            &:hover {
              background-color: #f1f1f5;
            }
            .name {
              flex: 1;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow-x: hidden;
              cursor: pointer;
              font-size: 12px;
              max-width: 155px;
              padding: 4px 0;
            }
            .icon-gongdanxitong {
              color:var(--g-color-primary);
              font-size: 12px;
              margin-right: 4px;
              cursor: pointer;
            }
            .el-icon-delete {
              cursor: pointer;
            }
            .is-active {
              color: #ff9300;
              max-width: 130px;
            }
          }
        }
        .el-scrollbar {
          height: calc(100% - 40px);
        }
        .el-scrollbar__wrap {
          height: 100%;
          overflow: auto;
        }
        .el-scrollbar__bar.is-horizontal {
          display: none;
        }
      }
      &_right {
        flex: 1;
        &-conent {
          padding: 0 12px;
          .tabs-content {
            // overflow: hidden;
          }
        }
        .item {
          position: relative;
          margin-right: 54px;
          padding: 1px 16px;
          border-top: 1px solid #c1bfc7;
          font-size: 12px;
          cursor: pointer;
          .item {
            margin-right: 0;
          }
          .sort-num {
            position: absolute;
            right: -38px;
            top: 0;
          }
          &:first-child {
            /*border-top: none;*/
            border-top-color: transparent;
          }
          &.is-active {
            background-color: aliceblue;
          }
          &_disabled {
            margin-right: 32px;
            pointer-events: none;
            padding: 1px 16px;
            border-top: 1px solid #c1bfc7;
            &:first-child {
              border-top: none;
            }
          }
        }
      }
      .collapse-select {
        position: relative;
        width: 200px;
        display: inline-block;
        &__content {
          position: absolute;
          top: 36px;
          left: 0;
          z-index: 99;
          width: 100%;
          padding: 6px 0;
          box-sizing: border-box;
          background-color: #fff;
          border: 1px solid #d2d2d6;
          border-radius: 2px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          &::before {
            position: absolute;
            width: 0;
            height: 0;
            content: "";
            top: -13px;
            left: 10px;
            border: 6px solid transparent;
            filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
            border-bottom-color: #ebeef5;
            z-index: 10;
          }
          &::after {
            position: absolute;
            width: 0;
            height: 0;
            content: '';
            top: -5px;
            left: 10px;
            border: 6px solid transparent;
            border-top-width: 0;
            border-bottom-color: #fff;
            z-index: 12;
          }
        }
        .iconc-clear {
          cursor: pointer;
        }
        &-btn-box {
          display:flex;
          justify-content: center;
          margin-top: 10px;
        }
        &-btn {
          min-width: 50px;
        }
        .el-scrollbar {
          // max-height: 150px;
          // min-height: 50px;
        }
        .el-scrollbar__wrap {
          height: 100%;
          overflow: auto;
          min-height: 50px;
          max-height: 150px;
          margin-bottom: 0!important;
        }
        .el-scrollbar__bar.is-horizontal {
          display: none;
        }
        /deep/ .arrow {
          position: absolute;
          right: 0;
          top: 1px;
          display: inline-block;
          font-size: 12px;
          height: 28px;
        }
        /deep/ .arrow-up {
          width: 0;
          height: 0;
          margin-top: 10px;
          border-color: #b7b7c7 transparent transparent;
          border-width: 6px 6px 0;
          border-radius: 8px 8px;
          border-style: solid;
          vertical-align: middle;
          transition: transform .3s;
          &::before {
            content: ""
          }
          &.active {
            transform: rotateZ(-180deg);
          }
        }
        /deep/ .el-input__inner{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/drag-duty-dialog.vue